import { Invoices, Notification, Notifications, Profile, User } from '~/types/types'

interface DemoUserStore {
  fetchUser: () => void
  fetchProfile: () => void
  fetchTopUnreadNotifications: () => void
  fetchNotifications: () => void
  markNotificationAsRead: () => void
  fetchInvoices: () => void
  updateProfile: () => void
  deactivateAccount: () => void
  user: User
  profile: Profile
  topUnreadNotifications: Notification<'WasteCollection' | 'Invoice' | 'WasteCollectionYardReport' | 'WasteLimitReached'>[]
  notifications: Notifications
  invoices: Invoices
}

export default (nuxtApp): DemoUserStore => {
  return {
    fetchUser: () => { },
    fetchProfile: () => { },
    fetchTopUnreadNotifications: () => { },
    fetchNotifications: () => { },
    markNotificationAsRead: () => { },
    fetchInvoices: () => { },
    updateProfile: () => { },
    deactivateAccount: () => { },
    user: {
      id: 1,
      name: 'John Doe',
      initials: 'JD',
      userName: 'johndoe',
      email: 'john@doe.com',
      phone: '774 712 123',
      subject: {
        id: 1,
        city: 'Ostrava',
        street: 'Ostravská 123',
        zipCode: '700 30',
      },
    },
    profile: {
      "id": 1,
      "name": "John Doe",
      "userName": "johndoe",
      "initials": "JD",
      "email": "john@doe.com",
      "phone": "774 712 123",
      "street": "Ostravská 123",
      "city": "Ostrava",
      "zip": "700 30"
    },
    topUnreadNotifications: [],
    notifications: {
      items: [],
      pagination: null,
    },
    invoices: {
      items: [],
      pagination: null,
    },
  }
}
